import { includes, isEmpty, isPlainObject } from 'lodash/fp';

// @ts-expect-error - Automatic, Please fix when editing this file
const getIsNoGapDentalProduct = ({ product, state }) => {
  if (!isPlainObject(product) || !product?.features?.noGapDental) {
    return false;
  }

  const limitedStates = product?.features?.noGapDentalLimited;

  return isEmpty(limitedStates) || includes(state, limitedStates);
};

export default getIsNoGapDentalProduct;
